import store from '@/store/store'
import { setCustomTextModal } from './action'
import { setModalCallbacks } from './callbackRegistry'

export function setShowModalCustomText(
  header: string,
  text: string,
  primaryButtonText: string = null,
  secondaryButtonText: string = null,
  showSecondaryButton: boolean = false,
  onPrimaryClick?: () => void,
  onSecondaryClick?: () => void,
  primaryButtonVariant?: 'default' | 'gradient' | 'super-gradient'
) {
  const callbackGeneration = setModalCallbacks({ onPrimary: onPrimaryClick, onSecondary: onSecondaryClick })
  store.dispatch(setCustomTextModal({ header, text, primaryButtonText, secondaryButtonText, showSecondaryButton, callbackGeneration, primaryButtonVariant }))
}

/**
 * The shared "Discard changes?" confirmation: Discard runs `onDiscard`, Cancel
 * keeps editing. Same copy as the editor inspector's discard prompt.
 */
export function confirmDiscardChanges(t: (key: string) => string, onDiscard: () => void) {
  setShowModalCustomText(
    t('Discard changes?'),
    t('Your changes will not be saved.'),
    t('Discard'),
    t('Cancel'),
    true,
    onDiscard,
  )
}
